<template>
  <div class="bg-light">
    <div class="livraison-page container">
      <div v-if="cartsupp && cartsupp.items">
        <div class="bg-light">
          <div class="container section-header-breadcrumb">
            <div class="row">
              <div class="content text-left col-sm-12 col-md-12 col-lg-12">
                <h2 class="title-page">
                  <span class="back-link cursor-pointer" @click="BackToLivraison"
                    ><i class="ti ti-back-left font-20 orange-color pe-2"></i
                  ></span>
                  Mode de livraison
                </h2>
                <label class="breadcrumb-text">
                  <span class="pointer-cursor" @click.prevent="GoToDashboard">Accueil</span> >
                  <span class="pointer-cursor" @click.prevent="GoToStepCart">Mon panier</span> >
                  <span class="cursor-pointer" @click="BackToLivraison"> Livraison > </span
                  ><span>Livraison à domicile</span></label
                >
              </div>
            </div>
          </div>
          <div class="livraison-page container">
            <div class="content d-flex flex-column flex-lg-row gap-4 gap-lg-5 mb-4 cart-page-inner">
              <div class="col-12 col-lg-8 block-adresses">
                <!-- Même approche que les autres composants - cacher step-cart-centent sur mobile -->
                <div class="row step-cart ps-5 pe-5">
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <div class="d-flex gap-4 align-items-center py-4 step-cart-centent">
                      <div class="step-number" @click.prevent="GoToStepCart">
                        <span class="badge mx-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="w-100 h-75"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="#ec621a"
                            stroke-width="3"
                          >
                            <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" /></svg
                        ></span>
                        <span class="step-title">Votre panier</span>
                      </div>
                      <div class="separator"></div>

                      <div class="step-number">
                        <span class="badge badge-blue mx-2">2</span>
                        <span class="step-title">Livraison</span>
                      </div>
                      <div class="separator"></div>

                      <div class="step-number">
                        <span class="badge mx-2">3</span>
                        <span class="step-title">Paiement</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="row justify-content-center mb-3 block-tunnel-domicile">
                    <div
                      class="col-12 col-lg-7 col-md-7 col-sm-7 d-flex align-items-center justify-content-center justify-content-lg-start"
                    >
                      <img :src="iconlocation" class="shipping-icon" />
                      <label class="title-blue my-auto px-2 text-center text-lg-start">Adresse de livraison</label>

                      <!-- Bouton de tri-->
                      <button
                        class="btn btn-sm btn-outline-blue d-flex align-items-center ms-2"
                        @click="toggleSortByLastName"
                        title="Trier par nom"
                      >
                        <!-- Icône dynamique -->
                        <span v-if="sortByLastName === null" v-html="svgDefault"></span>
                        <span v-else-if="sortByLastName === false" v-html="svgAsc"></span>
                        <span v-else v-html="svgDesc"></span>
                      </button>
                    </div>
                    <div class="col-12 col-lg-5 col-md-5 col-sm-5 text-center text-lg-end mt-2 mt-lg-0">
                      <a
                        href="#"
                        class="btn btn-orange w-100 w-lg-auto padding-btn"
                        @click.prevent="OpenAddNewAdressModal"
                      >
                        <img :src="plus" class="icon-plus me-2" />
                        Ajouter une nouvelle adresse
                      </a>
                    </div>
                  </div>
                  <div class="row justify-content-center liste-adresses">
                    <div class="col-12 col-lg-11 col-md-11 col-sm-11 my-2">
                      <div class="search-block w-100">
                        <form>
                          <input
                            type="text"
                            class="form-control"
                            v-model="searchAddress"
                            placeholder="Rechercher une adresse..."
                          />
                          <span class="search-btn">
                            <i class="ti ti-search"></i>
                          </span>
                        </form>
                      </div>
                    </div>
                    <div class="col-12 col-lg-11 col-md-11 col-sm-11 my-2">
                      <form class="radio-group" v-if="filteredAddresses.length > 0">
                        <div
                          v-for="adress in filteredAddresses"
                          :key="adress.id"
                          class="radio-option"
                          :class="{
                            selected: selectedLiv === adress.id,
                          }"
                          @click="selectedLiv = adress.id"
                        >
                          <!-- Contenu principal -->
                          <div class="location">
                            <div class="line1">
                              <img :src="user" />
                              <div class="radio-adresse">
                                {{ adress.firstName }}
                                {{ adress.lastName }}
                                <br />
                                <span v-if="adress.company">{{ adress.company }}<br /></span>
                                {{ adress.street }},
                                {{ adress.postcode }}
                                {{ adress.city }}
                              </div>
                            </div>
                            <div class="line2">
                              <div v-if="adress.cellphone" class="info-item">
                                <img :src="phone" />
                                <label>{{ adress.cellphone ?? "-" }}</label>
                              </div>
                              <div v-if="adress.email" class="info-item">
                                <img :src="envelope" />
                                <label>{{ adress.email ?? "-" }}</label>
                              </div>
                            </div>
                          </div>

                          <!-- Radio customisé à droite -->
                          <div class="custom-radio">
                            <input type="radio" :value="adress.id" v-model="selectedLiv" />
                            <img v-if="selectedLiv === adress.id" :src="checked" />
                          </div>
                        </div>
                      </form>
                      <div v-else class="text-center p-4">
                        <p class="mb-0">Vous n'avez pas encore d'adresse de livraison. Veuillez en ajouter une.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-4 py-3 block-recap">
                <label class="title-recap">Récapitulatif de la commande</label>

                <div v-if="showWarehouseNotice" class="alert alert-info my-3">
                  <i class="ti ti-info-circle"></i>
                  <p>
                    <strong>Information :</strong> Suite à un arrêté préfectoral en lien avec l'épisode de froid en
                    cours, les transporteurs ne sont pas autorisés à circuler dans la région de notre entrepôt
                    logistique avant la fin de journée du 06 janvier, au plus tôt. Cela peut donc entrainer un léger
                    retard dans la prise en charge de vos commandes par ces derniers.
                  </p>
                </div>

                <div class="my-3 my-md-4 d-flex justify-content-between align-items-center">
                  <label class="recap-text p-0">Prix des produits</label>
                  <span class="recap-text">{{ TotalCart }} € HT</span>
                </div>

                <div
                  class="my-3 my-md-4 d-flex justify-content-between align-items-center"
                  v-if="showRemiseLine && remise"
                >
                  <p class="col-6 col-lg-6 p-0">
                    <label class="recap-text">Remise</label>
                    <br />
                    <span class="text-slogan" v-if="couponCode"> {{ couponCode }} </span>
                    <span class="text-slogan" v-else>inclus dans le prix des produits</span>
                  </p>
                  <span class="recap-text">{{ remise }} €</span>
                </div>

                <div class="my-3 my-md-4 d-flex justify-content-between align-items-center" v-if="tvaTieCode === '0'">
                  <label class="recap-text p-0">TVA</label>
                  <span class="recap-text">{{ Tva }} €</span>
                </div>

                <div class="my-3 my-md-4 row">
                  <p class="col-12 col-lg-10">
                    <label class="recap-text">Livraison</label>
                    <br />
                    <span class="text-slogan">Frais calculés à l'étape suivante</span>
                  </p>
                </div>
                <hr class="divider" />
                <div class="my-3 my-md-4 d-flex justify-content-between align-items-center" v-if="tvaTieCode === '0'">
                  <label class="recap-text">Total TVA inclus</label>
                  <span class="recap-text-blue px-0">{{ TotalCartTTC }} € TTC</span>
                </div>
                <div class="my-3 my-md-4 d-flex justify-content-between align-items-center" v-else>
                  <label class="recap-text">Total</label>
                  <span class="recap-text-blue px-0">{{ TotalCartTTC }} € HT</span>
                </div>
                <div class="row">
                  <div class="col-12 text-center">
                    <button
                      class="btn text-white btn-check-order mt-2 w-100 w-lg-60"
                      :disabled="!selectedLiv || isSubmitting"
                      @click="ConfirmCommande()"
                    >
                      <span
                        v-if="isSubmitting"
                        class="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <span>{{ isSubmitting ? "Confirmation en cours..." : "Confirmer" }}</span>
                    </button>
                  </div>
                  <div class="col-12 text-center mt-2">
                    <span class="text-slogan mt-3">Paiement 100% sécurisé avec technologies ssl et 3D Secure.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ADD ADRESS MODAL -->
    <div
      class="modal fade"
      id="adressclient"
      ref="adressclient"
      tabindex="-1"
      aria-labelledby="modalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-width">
        <div class="modal-content">
          <div class="modal-header justify-content-end">
            <button type="button" class="close-link" data-bs-dismiss="modal" aria-label="Fermer">
              <i class="ti ti-close"></i>
            </button>
          </div>
          <div class="modal-body padd-modal">
            <h3>Ajout d'une nouvel adresse de livraison</h3>
            <form class="mt-4">
              <div class="d-flex flex-column flex-md-row gap-3">
                <div class="input-form flex-fill">
                  <label class="label-control">Nom*</label>
                  <input type="text" class="form-control" v-model="clientadress.lastName" />
                  <span v-if="erroradressLastName" class="error-message mb-1">{{ erroradressLastName }}</span>
                </div>
                <div class="input-form flex-fill">
                  <label class="label-control">Prénom*</label>
                  <input type="text" class="form-control" v-model="clientadress.firstName" />
                  <span v-if="erroradressFirstName" class="error-message mb-1">{{ erroradressFirstName }}</span>
                </div>
              </div>
              <div class="d-flex flex-column flex-md-row gap-3 mt-3">
                <div class="input-form flex-fill">
                  <label class="label-control">Société</label>
                  <input type="text" class="form-control" v-model="clientadress.company" />
                </div>
              </div>
              <div class="d-flex flex-column flex-md-row gap-3 mt-3">
                <div class="input-form flex-fill">
                  <label class="label-control">Adresse*</label>
                  <input type="text" class="form-control" v-model="clientadress.street" />
                  <span v-if="erroradressStreet" class="error-message mb-1">{{ erroradressStreet }}</span>
                </div>
                <div class="input-form flex-fill">
                  <label class="label-control">Code postal</label>
                  <input type="text" class="form-control" v-model="clientadress.postcode" v-only-digits />
                  <span v-if="erroradressCodePostal" class="error-message mb-1">{{ erroradressCodePostal }}</span>
                </div>
              </div>
              <div class="d-flex flex-column flex-md-row gap-3 mt-3">
                <div class="input-form flex-fill">
                  <label class="label-control">Ville</label>
                  <input type="text" class="form-control" v-model="clientadress.city" />
                  <span v-if="erroradressVille" class="error-message mb-1">{{ erroradressVille }}</span>
                </div>
                <div class="input-form client-pays flex-fill">
                  <label class="label-control">Pays</label>
                  <div class="dropdown w-100 mb-2">
                    <button
                      class="form-control dropdown-toggle w-100 text-start"
                      :class="{ error: erroradressPays }"
                      type="button"
                      @click="toggleDropdownCountry"
                    >
                      {{ selectedCountry.name || "Sélectionner un pays" }}
                    </button>
                    <div
                      class="dropdown-menu show w-100 p-2"
                      v-if="isOpenCountry"
                      style="max-height: 300px; overflow-y: auto"
                    >
                      <input
                        type="text"
                        class="form-control mb-2"
                        placeholder="Rechercher un pays..."
                        v-model="searchCountry"
                        @click.stop
                      />
                      <button
                        v-for="country in filteredCountries"
                        :key="country.code"
                        class="dropdown-item text-start"
                        @click="selectCountry(country)"
                      >
                        {{ country.name }}
                        <span v-if="selectedCountry.code === country.code" class="ms-2 text-success">✔</span>
                      </button>
                    </div>
                  </div>
                  <span v-if="erroradressPays" class="error-message mb-1">{{ erroradressPays }}</span>
                </div>
              </div>
              <div class="d-flex flex-column flex-md-row gap-3 mt-3">
                <div class="input-form flex-fill">
                  <label class="label-control">Email*</label>
                  <input type="email" class="form-control" v-model="clientadress.email" />
                  <small class="text-muted d-block mt-1">Utilisée pour les notifications de suivi du colis</small>
                  <span v-if="erroradressEmail" class="error-message mb-1">{{ erroradressEmail }}</span>
                </div>
                <div class="input-form flex-fill">
                  <label class="label-control">Téléphone*</label>
                  <input type="tel" class="form-control" v-model="clientadress.cellphone" v-only-digits />
                  <span v-if="erroradressCellphone" class="error-message mb-1">{{ erroradressCellphone }}</span>
                </div>
              </div>
              <div class="d-flex justify-content-center mt-4">
                <button
                  class="btn btn-orange w-100 w-md-auto"
                  id="save-client-adress"
                  @click.prevent="AddNewAdressClient"
                >
                  Enregistrer
                </button>
              </div>
              <div v-if="successadressMessage" class="alert alert-success mt-4 w-100 w-md-50 content-centered">
                <span class="success-message">{{ successadressMessage }}</span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import iconlocation from "@/assets/location.svg";
  import user from "@/assets/images/user.svg";
  import phone from "@/assets/images/phone.svg";
  import envelope from "@/assets/images/envelope.svg";
  import checked from "@/assets/images/check-box-orange.png";
  import plus from "@/assets/images/plus-circle.svg";
  import { useCartStore } from "@/stores/cartStore";
  import { useRegisterStore } from "@/stores/register";
  import { useAddressesStore } from "@/stores/esupplyvet/addressesStore";
  import { Modal } from "bootstrap";
  import { getCountries, CreateNewAdressClient } from "@/api/auth";
  import { updateOrder } from "@/api/orders";
  import { useCheckoutStore } from "@/stores/useCheckoutStore";
  import { useDelegueStore } from "@/stores/delegueStore";

  export default {
    name: "LivraisonCliniquePage",
    data() {
      return {
        user,
        phone,
        envelope,
        checked,
        plus,
        cart: {
          items: [],
        },
        cartStore: null,
        registerStore: null,
        addressesStore: null,
        iconlocation,
        selectedLiv: null,
        sortByLastName: null,
        isSubmitting: false,
        searchAddress: "", // New data property for search input
        svgDefault: `
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32" fill="none" stroke="#1e347d" stroke-width="2">
            <text x="4" y="12" font-family="system-ui, sans-serif" font-size="11" font-weight="bold" fill="#1e347d">A</text>
            <text x="4" y="24" font-family="system-ui, sans-serif" font-size="11" font-weight="bold" fill="#1e347d">Z</text>
            <line x1="16" y1="6" x2="16" y2="26" stroke="#1e347d" stroke-width="2"/>
            <line x1="20" y1="8" x2="28" y2="8" stroke="#1e347d" stroke-width="2"/>
            <line x1="20" y1="16" x2="26" y2="16" stroke="#1e347d" stroke-width="2"/>
            <line x1="20" y1="24" x2="24" y2="24" stroke="#1e347d" stroke-width="2"/>
          </svg>
        `,
        svgAsc: `
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32" fill="none" stroke="#1e347d" stroke-width="2">
            <text x="4" y="12" font-family="system-ui, sans-serif" font-size="11" font-weight="bold" fill="#1e347d">A</text>
            <text x="4" y="24" font-family="system-ui, sans-serif" font-size="11" font-weight="bold" fill="#1e347d">Z</text>
            <line x1="16" y1="6" x2="16" y2="26" stroke="#1e347d" stroke-width="2"/>
            <polyline points="12,10 16,6 20,10" fill="none" stroke="#1e347d" stroke-width="2"/>
            <line x1="24" y1="8" x2="28" y2="8" stroke="#1e347d" stroke-width="2"/>
            <line x1="24" y1="16" x2="26" y2="16" stroke="#1e347d" stroke-width="2"/>
            <line x1="24" y1="24" x2="30" y2="24" stroke="#1e347d" stroke-width="2"/>
          </svg>
        `,
        svgDesc: `
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32" fill="none" stroke="#1e347d" stroke-width="2">
            <text x="4" y="12" font-family="system-ui, sans-serif" font-size="11" font-weight="bold" fill="#1e347d">Z</text>
            <text x="4" y="24" font-family="system-ui, sans-serif" font-size="11" font-weight="bold" fill="#1e347d">A</text>
            <line x1="16" y1="6" x2="16" y2="26" stroke="#1e347d" stroke-width="2"/>
            <polyline points="12,22 16,26 20,22" fill="none" stroke="#1e347d" stroke-width="2"/>
            <line x1="24" y1="8" x2="30" y2="8" stroke="#1e347d" stroke-width="2"/>
            <line x1="24" y1="16" x2="26" y2="16" stroke="#1e347d" stroke-width="2"/>
            <line x1="24" y1="24" x2="28" y2="24" stroke="#1e347d" stroke-width="2"/>
          </svg>
        `,
        clientadress: {
          firstName: "",
          lastName: "",
          company: "",
          street: "",
          postcode: "",
          city: "",
          countryCode: "",
          email: "",
          cellphone: "",
        },
        selectedCountry: {},
        isOpenCountry: false,
        searchCountry: "",
        countries: [],
        erroradressLastName: "",
        erroradressFirstName: "",
        erroradressStreet: "",
        erroradressCodePostal: "",
        erroradressVille: "",
        erroradressPays: "",
        canStoreClientadress: true,
        isLoadingClientadress: false,
        successadressMessage: "",
        erroradressEmail: "",
        erroradressCellphone: "",
      };
    },
    computed: {
      filteredCountries() {
        const query = this.searchCountry.toLowerCase();
        return this.countries.filter(country => country.name.toLowerCase().includes(query));
      },
      filteredAddresses() {
        let addresses = this.addressesStore.homeAddresses || [];
        if (this.searchAddress !== "") {
          const query = this.searchAddress.toLowerCase();
          addresses = addresses.filter(
            addr =>
              (addr.firstName + " " + addr.lastName)?.toLowerCase().includes(query) ||
              addr.street?.toLowerCase().includes(query) ||
              addr.postcode?.toLowerCase().includes(query) ||
              addr.city?.toLowerCase().includes(query) ||
              addr.email?.toLowerCase().includes(query) ||
              addr.cellphone?.toLowerCase().includes(query)
          );
        }
        let sorted = [...addresses];
        if (this.sortByLastName !== null) {
          sorted.sort((a, b) => {
            const nameA = (a.lastName || "").trim().toLowerCase();
            const nameB = (b.lastName || "").trim().toLowerCase();
            if (this.sortByLastName) {
              return nameB.localeCompare(nameA); // Descendant Z->A
            } else {
              return nameA.localeCompare(nameB); // Ascendant A->Z
            }
          });
        } else {
          sorted.sort((a, b) => {
            const dateA = a.createdAt ? new Date(a.createdAt) : new Date(0);
            const dateB = b.createdAt ? new Date(b.createdAt) : new Date(0);
            return dateB - dateA;
          });
        }
        return sorted;
      },
      TotalCart() {
        var total = 0;
        var cartStore = useCartStore();
        if (cartStore.Cart && cartStore.Cart.items && cartStore.Cart.items.length > 0)
          total = cartStore.Cart.itemsSubtotal / 100;
        return this.formatPrice(total);
      },
      Tva() {
        var total = 0;
        var cartStore = useCartStore();
        if (cartStore.Cart && cartStore.Cart.items && cartStore.Cart.items.length > 0)
          total = (cartStore.Cart.taxTotal - (cartStore.Cart.shippingTotal - cartStore.Cart.shippingTaxTotal)) / 100;
        return this.formatPrice(total);
      },
      remise() {
        var total = 0;
        var cartStore = useCartStore();
        total = cartStore.Cart.orderPromotionTotal / 100;
        return total ? this.formatPrice(total) : 0;
      },
      couponCode() {
        const cartStore = useCartStore();
        return cartStore.Cart?.coupon_code || "";
      },
      tvaTieCode() {
        var cartStore = useCartStore();
        return cartStore.Cart.tvaTieCode;
      },
      TotalCartTTC() {
        var total = 0;
        var cartStore = useCartStore();
        if (cartStore.Cart && cartStore.Cart.items && cartStore.Cart.items.length > 0)
          total = cartStore.Cart.itemsTotal / 100;
        return this.formatPrice(total);
      },
      cartsupp() {
        var cartStore = useCartStore();
        return cartStore.Cart;
      },
      isDelegue() {
        return this.registerStore.user?.role === "delegues";
      },
      ListAddressesFacturations() {
        const cartStore = useCartStore();
        if (this.isDelegue && cartStore.Cart?.vetCustomer?.adressesFacturation) {
          console.log("Using delegate vet billing address from cart");
          return cartStore.Cart.vetCustomer.adressesFacturation;
        } else {
          console.log("Using regular vet billing address from register store");
          return this.registerStore.Veterinaire?.adressesFacturation;
        }
      },
      ListAddressesDomicile() {
        return this.filteredAddresses;
      },
      loading() {
        return this.cartStore.loading;
      },
      isClient() {
        return this.registerStore.user?.role === "client";
      },
      userRole() {
        return this.registerStore.user?.role;
      },
      selectedVetForDelegue() {
        const delegueStore = useDelegueStore();
        return delegueStore.selectedVeterinarian;
      },

      showWarehouseNotice() {
        const today = new Date();
        const deadline = new Date("2026-01-07T00:00:00");
        return today < deadline;
      },
      showRemiseLine() {
        const subtotal = this.cartsupp?.itemsSubtotal || 0;
        const remiseValue = Math.abs(this.cartsupp?.orderPromotionTotal || 0);
        return subtotal > 0 && remiseValue > 0 && remiseValue < subtotal;
      },
    },
    created() {
      this.registerStore = useRegisterStore();
      this.addressesStore = useAddressesStore();
      this.registerStore.fetchVeterinaire();
      this.addressesStore.fetchAddresses();
      this.GetPays();
    },
    methods: {
      toggleSortByLastName() {
        if (this.sortByLastName === null) {
          this.sortByLastName = false;
        } else if (this.sortByLastName === false) {
          this.sortByLastName = true;
        } else {
          this.sortByLastName = null;
        }
      },
      formatPrice(value) {
        if (value == null || isNaN(value)) return "0,00";
        const num = Number(value);
        return num.toFixed(2).replace(".", ",");
      },
      async ConfirmCommande() {
        if (this.isSubmitting) return;

        try {
          const order = this.cartsupp;
          const tokenValue = order?.tokenValue;
          if (!tokenValue) {
            console.error("Aucun tokenValue pour la commande");
            return;
          }
          const selectedAddressId = this.selectedLiv;
          let shippingAddress = null;
          shippingAddress = this.addressesStore.homeAddresses.find(addr => addr.id === selectedAddressId);
          if (!shippingAddress) {
            console.error("Adresse de livraison introuvable");
            return;
          }

          this.isSubmitting = true;

          const shippingAddressPayload = {
            firstName: shippingAddress.firstName,
            lastName: shippingAddress.lastName,
            company: shippingAddress.company || null,
            street: shippingAddress.street,
            postcode: shippingAddress.postcode,
            city: shippingAddress.city,
            cellphone: shippingAddress.cellphone,
            email: shippingAddress.email,
            countryCode: shippingAddress.countryCode,
            adrcod: shippingAddress.adrcod || null,
          };
          let billingAddressPayload = null;
          const defaultBillingAddress = this.ListAddressesFacturations;
          if (defaultBillingAddress && defaultBillingAddress.id) {
            billingAddressPayload = {
              firstName: defaultBillingAddress.firstName,
              lastName: defaultBillingAddress.lastName,
              street: defaultBillingAddress.street,
              postcode: defaultBillingAddress.postcode,
              city: defaultBillingAddress.city,
              cellphone: defaultBillingAddress.cellphone,
              email: defaultBillingAddress.email,
              countryCode: defaultBillingAddress.countryCode,
              adrcod: defaultBillingAddress.adrcod || null,
            };
          } else {
            billingAddressPayload = shippingAddressPayload;
          }
          const couponCodePayload = order.coupon_code || "";
          const payload = {
            billingAddress: billingAddressPayload,
            shippingAddress: shippingAddressPayload,
          };
          if (couponCodePayload) {
            payload.couponCode = couponCodePayload;
          }
          const checkoutStore = useCheckoutStore();
          const delegueStore = useDelegueStore();
          const registerStore = useRegisterStore();
          const vetId = delegueStore.getSelectedVeterinarian?.id;
          const userRole = registerStore.user?.role || "";
          const response = await updateOrder(tokenValue, payload, userRole === "delegues", vetId);
          checkoutStore.setOrder(response.data);
          this.$router.push({ name: "mode-paiement" });
        } catch (error) {
          console.error("Erreur lors de la confirmation de la commande :", error);
        } finally {
          this.isSubmitting = false;
        }
      },
      GoToStepCart() {
        this.$router.push({ name: "my-cart" });
      },
      BackToLivraison() {
        this.$router.push({ name: "livraison" });
      },
      GoToDashboard() {
        this.$router.push({ name: "dashboard-home" });
      },
      OpenAddNewAdressModal() {
        this.ResetFormClientAdress();
        const modalElement = this.$refs.adressclient;
        const modalInstance = Modal.getOrCreateInstance(modalElement);
        modalInstance.show();
      },
      GetPays() {
        getCountries()
          .then(res => {
            this.countries = res.data;
          })
          .catch(() => {});
      },
      toggleDropdownCountry() {
        this.isOpenCountry = !this.isOpenCountry;
      },
      selectCountry(country) {
        this.selectedCountry = country;
        this.clientadress.countryCode = country.code;
        this.isOpenCountry = false;
        this.searchCountry = "";
      },
      AddNewAdressClient() {
        this.erroradressLastName = "";
        this.erroradressFirstName = "";
        this.erroradressStreet = "";
        this.erroradressCodePostal = "";
        this.erroradressVille = "";
        this.erroradressPays = "";
        this.canStoreClientadress = true;
        this.isLoadingClientadress = true;
        this.successadressMessage = "";
        this.erroradressEmail = "";
        this.erroradressCellphone = "";
        const spinner =
          '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Enregistrement en cours ...';
        document.getElementById("save-client-adress").innerHTML = spinner;
        this.CheckValidateClientAdress();
        if (this.canStoreClientadress) {
          this.clientadress.divalto_id = this.registerStore.Veterinaire.divalto_id;
          CreateNewAdressClient(this.clientadress, this.userRole, this.selectedVetForDelegue?.id)
            .then(res => {
              if (res.data && res.data.id) {
                const newAddressId = res.data.id;
                this.sortByLastName = null;
                this.addressesStore.fetchAddresses().then(() => {
                  this.$nextTick(() => {
                    this.selectedLiv = newAddressId;
                    this.successadressMessage = "Votre nouvelle adresse a été ajoutée avec succès";
                    setTimeout(() => {
                      this.successadressMessage = "";
                      const modalElement = this.$refs.adressclient;
                      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
                      modalInstance.hide();
                      this.$nextTick(() => {
                        const addressList = document.querySelector(".liste-adresses");
                        if (addressList) {
                          addressList.scrollTop = 0;
                        }
                      });
                    }, 1000);
                  });
                });
              }
              document.getElementById("save-client-adress").innerHTML = "Enregistrer";
              this.isLoadingClientadress = false;
            })
            .catch(() => {
              this.isLoadingClientadress = false;
              document.getElementById("save-client-adress").innerHTML = "Enregistrer";
            });
        } else {
          document.getElementById("save-client-adress").innerHTML = "Enregistrer";
          this.isLoadingClientadress = false;
        }
      },
      CheckValidateClientAdress() {
        if (this.clientadress.lastName == "") {
          this.erroradressLastName = "Le champ nom est obligatoire";
          this.canStoreClientadress = false;
        }
        if (this.clientadress.firstName == "") {
          this.erroradressFirstName = "Le champ prénom est obligatoire";
          this.canStoreClientadress = false;
        }
        if (this.clientadress.street == "") {
          this.erroradressStreet = "Le champ addresse est obligatoire";
          this.canStoreClientadress = false;
        }
        if (this.clientadress.postcode == "") {
          this.erroradressCodePostal = "Le champ Code postal est obligatoire";
          this.canStoreClientadress = false;
        }
        if (this.clientadress.city == "") {
          this.erroradressVille = "Le champ ville est obligatoire";
          this.canStoreClientadress = false;
        }
        if (this.clientadress.countryCode == "") {
          this.erroradressPays = "Le champ pays est obligatoire";
          this.canStoreClientadress = false;
        }
        if (this.clientadress.email == "") {
          this.erroradressEmail = "Le champ email est obligatoire";
          this.canStoreClientadress = false;
        } else if (!this.isValidEmail(this.clientadress.email)) {
          this.erroradressEmail = "Veuillez entrer un email valide";
          this.canStoreClientadress = false;
        }
        if (this.clientadress.cellphone == "") {
          this.erroradressCellphone = "Le champ téléphone est obligatoire";
          this.canStoreClientadress = false;
        } else if (!this.isValidPhoneNumber(this.clientadress.cellphone)) {
          this.erroradressCellphone = "Veuillez entrer un numéro de téléphone valide";
          this.canStoreClientadress = false;
        }
        if (!this.canStoreClientadress) {
          this.isLoadingClientadress = false;
          document.getElementById("save-client-adress").innerHTML = "Enregistrer";
        }
      },
      isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
      },
      isValidPhoneNumber(cellphone) {
        const phoneRegex = /^\+?\d[\d\s-]{8,}$/;
        return phoneRegex.test(cellphone);
      },
      ResetFormClientAdress() {
        this.clientadress = {
          firstName: "",
          lastName: "",
          company: "",
          street: "",
          postcode: "",
          city: "",
          countryCode: "",
          email: "",
          cellphone: "",
        };
        this.selectedCountry = {};
        this.erroradressLastName = "";
        this.erroradressFirstName = "";
        this.erroradressStreet = "";
        this.erroradressCodePostal = "";
        this.erroradressVille = "";
        this.erroradressPays = "";
        this.canStoreClientadress = true;
        this.isLoadingClientadress = false;
        this.successadressMessage = "";
        this.erroradressEmail = "";
        this.erroradressCellphone = "";
      },
    },
  };
</script>

<style scoped>
  .livraison-page {
    padding: 15px;
    text-align: center;
    background: #f5f6f9;
    min-height: 500px;
  }

  .section-header-breadcrumb {
    text-align: left;
    font-style: normal;
    padding: 0 15px;

    .title-page {
      font-size: 30px;
      font-weight: bold;
      color: #1e347d;
    }

    label {
      font-size: 15px;
      font-weight: normal;

      span {
        color: #1e347d;
      }
    }
  }

  .step-cart {
    justify-content: center;
    margin-bottom: 3rem;
  }

  .title-blue {
    color: #1e347d;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
  }

  .step-cart-centent {
    justify-content: center;
    border: 1px solid #aeb1ba;
    border-radius: 10px;
  }

  .badge-blue {
    background-color: #1e347d !important;
    color: white !important;
    border-radius: 50%;
    font-size: 1.5rem;
  }

  .badge {
    background-color: #eee;
    color: #ec621a;
    border-radius: 50%;
    font-size: 1.5rem;
  }

  .step-cart .step-title {
    color: #000;
    font-weight: bold;
    font-size: 18px;
    opacity: 0.7;
  }

  .radio-group {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .radio-option {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 2px solid #aeb1ba;
    padding: 16px;
    border-radius: 12px;
    cursor: pointer;
    transition: border-color 0.3s;
  }

  .radio-option:hover,
  .radio-option.selected {
    background: #f5f6f9 0% 0% no-repeat padding-box;
    border: 2px solid #1e347d;
  }

  .location {
    flex: 1;
  }

  .radio-adresse {
    text-align: justify;
    font-family: "DM Sans", sans-serif !important;
  }

  .line1 {
    display: flex;
    align-items: center;
    color: #363739;
    font-size: 15px;
    margin-bottom: 8px;
    gap: 8px;
    font-family: "DM Sans", sans-serif !important;
  }

  .line2 {
    display: flex;
    color: #363739;
    font-size: 15px;
    gap: 16px;
    font-family: "DM Sans", sans-serif !important;
  }

  .info-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
  }

  .custom-radio {
    position: relative;
    padding-left: 24px;
    display: flex;
    align-items: center;
  }

  .custom-radio input[type="radio"] {
    opacity: 0;
    position: absolute;
    right: 0;
    height: 0;
    width: 0;
  }

  .block-recap {
    background: white;
    text-align: left;
    padding: 30px;
    max-height: max-content;
    border: 1px solid #ddd;
    border-radius: 10px;
    box-shadow: 0px 10px 6px rgba(0, 0, 0, 0.1);

    .title-recap {
      color: #1e347d;
      font-size: 20px;
      font-weight: bold;
    }

    .recap-text {
      font-size: 20px;
    }

    .recap-text-blue {
      font-size: 20px;
      color: #1e347d;
      font-weight: bold;
    }

    .text-slogan {
      font-size: 12px;
      color: #1e347d;
      font-style: italic;
    }

    .divider {
      width: 90%;
      position: relative;
      left: 5%;
    }
  }

  .modal-width {
    max-width: 600px;
  }

  .padd-modal {
    padding: 20px 40px;
  }

  .close-link {
    background: none;
    border: none;
    font-size: 1.5rem;
    color: #6c757d;
  }

  .error-message {
    color: red;
    font-size: 0.8rem;
  }

  .success-message {
    color: green;
    font-size: 0.9rem;
  }

  .content-centered {
    margin: 0 auto;
  }
  .btn-orange {
    padding: auto !important;
  }
  .block-tunnel-domicile {
    margin: 30px;
  }
  .search-block {
    position: relative;
  }
  .search-btn {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
  }

  /* Responsive Styles pour mobiles uniquement - Même approche que les autres composants */
  @media (max-width: 768px) {
    /* Cacher step-cart-centent exactement comme dans Livraison.vue et LivraisonClinique.vue */
    .step-cart-centent {
      display: none !important;
    }

    .livraison-page {
      padding: 10px;
    }

    .section-header-breadcrumb {
      padding: 0 10px;
      text-align: center;
    }

    .section-header-breadcrumb .title-page {
      font-size: 24px;
      text-align: center;
    }

    .section-header-breadcrumb .breadcrumb-text {
      font-size: 14px;
      text-align: center;
    }

    .content.cart-page-inner {
      gap: 20px !important;
    }

    .block-adresses {
      margin-bottom: 1rem;
    }

    .step-cart {
      margin-bottom: 1.5rem;
    }

    .title-blue {
      font-size: 16px;
    }

    .shipping-icon {
      width: 20px;
      height: 20px;
    }

    .radio-option {
      padding: 12px;
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
    }

    .custom-radio {
      align-self: flex-end;
      padding-left: 0;
    }

    .line1 {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }

    .line2 {
      flex-direction: column;
      gap: 8px;
    }

    .radio-adresse {
      font-size: 14px;
    }

    .block-recap {
      padding: 20px;
    }

    .block-recap .title-recap {
      font-size: 18px;
      text-align: center;
      display: block;
      width: 100%;
    }

    .block-recap .recap-text,
    .block-recap .recap-text-blue {
      font-size: 16px;
    }

    .btn-check-order {
      width: 100%;
      padding: 12px;
    }

    .back-link {
      display: inline-block;
      margin-bottom: 0.5rem;
    }

    .separator {
      display: none;
    }

    .block-tunnel-domicile {
      margin: 20px 0;
    }

    .padd-modal {
      padding: 15px 20px;
    }

    .modal-width {
      max-width: 95%;
      margin: 0 auto;
    }

    .padding-btn {
      padding: 10px !important;
    }
  }

  @media (max-width: 576px) {
    .padding-btn {
      padding: 10px !important;
    }
    .section-header-breadcrumb .title-page {
      font-size: 20px;
    }

    .breadcrumb-text {
      font-size: 13px !important;
    }

    .title-blue {
      font-size: 15px;
    }

    .radio-option {
      padding: 10px;
    }

    .block-recap {
      padding: 15px;
    }

    .block-recap .recap-text,
    .block-recap .recap-text-blue {
      font-size: 15px;
    }

    .radio-adresse {
      font-size: 13px;
    }

    .line1,
    .line2 {
      font-size: 14px;
    }

    .block-tunnel-domicile {
      margin: 15px 0;
    }
  }

  /* Pour les très petits écrans */
  @media (max-width: 360px) {
    .section-header-breadcrumb .title-page {
      font-size: 18px;
    }

    .breadcrumb-text {
      font-size: 12px !important;
    }

    .radio-option {
      padding: 8px;
    }

    .block-recap {
      padding: 12px;
    }

    .padd-modal {
      padding: 10px 15px;
    }
  }
</style>
